export enum TaxTagTypes {
  PERCENT = 1,
  FIXED = 2
}

export enum TaxTagBaseTypes {
  NET = "net",
  NET_TAXES = "net_taxes"
}

export enum AppliedTaxTagReason {
  LOCATION_COUNTRY = "location_country",
  LOCATION_REGION = "location_region",
  LOCATION_POST_CODE = "location_post_code"
}

export enum TaxCodesTypes {
  VAT = "VAT",
  SGST = "SGST",
  CGST = "CGST",
  IGST = "IGST",
  UGST = "UGST",
  GST_AU = "GST_AU",
  GST_CA = "GST_CA",
  HST = "HST",
  PST = "PST",
  QST = "QST"
}
